import api from "../Service/Api"
import { toastr } from "react-redux-toastr"

const cmMgtBaseController = "api/corp-member"

export const createInCampTrainingApi = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${cmMgtBaseController}/create-in-camp-training`, body)
      toastr.success('SAED Training registered successfully!')
      return response.data.data;
    }
  } catch (error) {
    if (error.code === 'ERR_BAD_REQUEST') {
      toastr.error("An error occurred", error.response.data.message)
    } else if (error.code === 'ERR_BAD_RESPONSE') { // error from server
      toastr.error("We encountered an error processing that request", "Please try again shortly")
    }
    throw error;
  }
}

export const updateInCampTrainingApi = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${cmMgtBaseController}/update-in-camp-training`, body)
      toastr.success('SAED Training updated successfully!')
      return response.data.data;
    }
  } catch (error) {
    if (error.code === 'ERR_BAD_REQUEST') {
      toastr.error("An error occurred", error.response.data.message)
    } else if (error.code === 'ERR_BAD_RESPONSE') { // error from server
      toastr.error("We encountered an error processing that request", "Please try again shortly")
    }
    throw error;
  }
}
